module.exports = __webpack_public_path__ + "img/wand-magic-sparkles.b51be6f2.svg";